document.addEventListener("DOMContentLoaded", () => {
  const config = window.VIP_CONFIG;

  if (!config || !config.isVip || !config.isEligibleProduct) {
    return;
  }

  function applyVipDiscountToWidget() {
    const widget = document.querySelector('recharge-subscription-widget');
    const shadow = widget?.shadowRoot;

    if (!shadow) {
      return false;
    }

    // 1. Inject your exact badge CSS rules inside the Shadow DOM
    if (!shadow.querySelector('#vip-pill-style')) {
      const style = document.createElement('style');
      style.id = 'vip-pill-style';
      style.textContent = `
        .vip-price-block {
          font-weight: 600;
          background-image: linear-gradient(45deg, #a8bee0, #d7e4f2);
          padding: 2px 8px;
          border-radius: 20px;
          margin-bottom: 5px;
          display: block;
          font-style: normal;
          font-size: 11px;
          text-align: center;
          width: fit-content;
          color: #000000;
        }
      `;
      shadow.appendChild(style);
    }

    // Target the "Buy Once" price container
    const buyOncePriceEl = shadow.querySelector(
      '.rc-purchase-option__prices.buy-once-opt .rc-price, ' +
      '.rc-purchase-option__onetime .rc-price, ' +
      '[part~="rc-purchase-option__selector_onetime"] + .rc-purchase-option__prices .rc-price, ' +
      '.rc-selection__onetime .rc-price'
    );

    if (!buyOncePriceEl) {
      return false;
    }

    if (buyOncePriceEl.getAttribute('data-vip-applied') === 'true') {
      return true;
    }

    const rawText = buyOncePriceEl.textContent.trim();
    const originalPrice = parseFloat(rawText.replace(/[^0-9.]/g, ''));

    if (!isNaN(originalPrice) && originalPrice > 0) {
      const discountedPrice = (originalPrice * (1 - config.discountRate)).toFixed(2);
      const symbol = rawText.match(/[^0-9.]/) ? rawText.match(/[^0-9.]/)[0] : '$';

      // Temporarily pause observer to prevent mutation loops
      if (window.vipObserver) window.vipObserver.disconnect();

      // Render your styled pill badge + strikethrough price
      buyOncePriceEl.innerHTML = `
        <div style="display: flex; flex-direction: column; align-items: flex-end;">
          <span class="vip-price-block">VIP 10% Off</span>
          <div>
            <span style="text-decoration: line-through; opacity: 0.6; margin-right: 6px;">
              ${symbol}${originalPrice.toFixed(2)}
            </span>
            <span style="font-weight: bold;">
              ${symbol}${discountedPrice}
            </span>
          </div>
        </div>
      `;

      buyOncePriceEl.setAttribute('data-vip-applied', 'true');

      // Re-engage observer for variant switches
      if (window.vipObserver && widget.shadowRoot) {
        window.vipObserver.observe(widget.shadowRoot, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
      return true;
    }

    return false;
  }

  function initVipPriceObserver() {
    const widget = document.querySelector('recharge-subscription-widget');

    if (widget?.shadowRoot) {
      window.vipObserver = new MutationObserver(() => {
        applyVipDiscountToWidget();
      });

      window.vipObserver.observe(widget.shadowRoot, {
        childList: true,
        subtree: true,
        characterData: true
      });

      applyVipDiscountToWidget();
    } else {
      setTimeout(initVipPriceObserver, 150);
    }
  }

  initVipPriceObserver();
});